import {
  AppTable,
  AppTableCell,
  AppTableRow,
  RowNumberCell,
} from "../../../components/ui";
import { LitigationFunnelTask } from "../../../api/models/LitigationFunnelMatter";
import { Areas } from "./Areas";

interface Props {
  children?: React.ReactNode;
  index: number;
  value: number;
  tasks: LitigationFunnelTask[]
}

const TABLE_COLUMNS = [
  { id: "task", label: "Task", sortable: false },
  { id: "dueDate", label: "Due Date", sortable: false },
  { id: "assignedTo", label: "Assigned To", sortable: false },
  { id: "funnel", label: "Funnel", sortable: false },
];

export function TaskTable(props: Props) {
  const { children, value, index, tasks, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <AppTable
          columns={TABLE_COLUMNS}
          showRowNumber
          maxHeight={400}
          stickyHeader
          isEmpty={tasks.length === 0}
          emptyTitle="No tasks"
        >
          {tasks.map((task, rowIndex) => (
            <AppTableRow
              key={rowIndex}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <RowNumberCell value={rowIndex + 1} />
              <AppTableCell>{task.task.name}</AppTableCell>
              <AppTableCell>
                {task.task.due_at
                  ? new Date(task.task.due_at).toLocaleDateString("en-US")
                  : "N/A"}
              </AppTableCell>
              <AppTableCell>{task.task.assignee.name}</AppTableCell>
              <AppTableCell>
                {Areas.find((area) => area.area === task.area)?.name}
              </AppTableCell>
            </AppTableRow>
          ))}
        </AppTable>
      )}
    </div>
  );
}
